import { render, staticRenderFns } from "./TypeID.vue?vue&type=template&id=2729d64c&"
import script from "./TypeID.vue?vue&type=script&lang=ts&"
export * from "./TypeID.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports